import React from 'react';
import { Modal, Button, Space, Typography } from 'antd';
import {
  FileTextOutlined,
  MessageOutlined,
  HistoryOutlined,
} from '@ant-design/icons';

const { Title, Text } = Typography;

const NewConversationDialog = ({ open, onClose, onSelectOption, hasLastContext }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={500}
      title={
        <div>
          <Title level={4} style={{ margin: 0 }}>
            Start New Conversation
          </Title>
          <Text type="secondary">Choose how you'd like to begin</Text>
        </div>
      }
    >
      <Space direction="vertical" size={16} style={{ width: '100%', marginTop: 16 }}>
        <Button
          size="large"
          icon={<FileTextOutlined />}
          onClick={() => onSelectOption('specify')}
          style={{
            width: '100%',
            height: 'auto',
            padding: '16px',
            textAlign: 'left',
            display: 'flex',
            alignItems: 'flex-start',
          }}
        >
          <div style={{ flex: 1, marginLeft: 8 }}>
            <div style={{ fontWeight: 'bold', marginBottom: 4 }}>
              Specify Requirements
            </div>
            <Text type="secondary" style={{ fontSize: 12 }}>
              Provide detailed context about your strategic objective
            </Text>
          </div>
        </Button>

        <Button
          size="large"
          icon={<MessageOutlined />}
          onClick={() => onSelectOption('chat')}
          style={{
            width: '100%',
            height: 'auto',
            padding: '16px',
            textAlign: 'left',
            display: 'flex',
            alignItems: 'flex-start',
          }}
        >
          <div style={{ flex: 1, marginLeft: 8 }}>
            <div style={{ fontWeight: 'bold', marginBottom: 4 }}>
              Start Chat
            </div>
            <Text type="secondary" style={{ fontSize: 12 }}>
              Begin a conversation without providing context
            </Text>
          </div>
        </Button>

        {hasLastContext && (
          <Button
            size="large"
            icon={<HistoryOutlined />}
            onClick={() => onSelectOption('usePrevious')}
            style={{
              width: '100%',
              height: 'auto',
              padding: '16px',
              textAlign: 'left',
              display: 'flex',
              alignItems: 'flex-start',
            }}
          >
            <div style={{ flex: 1, marginLeft: 8 }}>
              <div style={{ fontWeight: 'bold', marginBottom: 4 }}>
                Use Previous Context
              </div>
              <Text type="secondary" style={{ fontSize: 12 }}>
                Continue with your last company information
              </Text>
            </div>
          </Button>
        )}
      </Space>
    </Modal>
  );
};

export default NewConversationDialog;
